import { PROFILE } from "src/Actions/Profile/types";

export const initialState = {
  emailId: '',
  fieldValue: {},
  formError: {},
  isErrorDisplay: false,
  showToast: false,
  showNativeToast: false,
  isLoading: false,
  isProfileDetailsLoading: false,
  profileDetails: null,
  accrediting: [],
  languages: [],
  jobDetails: [],
  departments: [],
}

const profileReducer = (state = initialState, action) => { //NOSONAR
  switch (action.type) {
    case PROFILE.GET_PROFILE_DETAILS: {
      let { emailId } = action;
      return {
        ...state,
        emailId,
        isProfileDetailsLoading: state.profileDetails ? false : true
      }
    }
    case PROFILE.GET_PROFILE_DETAILS_SUCCESS: {
      let { response } = action;
      let formattedAccrediting = response.accreditingTypesList?.map((item) => {
        return {
            key: item,
            text: item
        }
    });
      return {
        ...state,
        fieldValue: response,
        profileDetails: response,
        isProfileDetailsLoading: false,
        accrediting: formattedAccrediting ? formattedAccrediting : []
      }
    }
    case PROFILE.GET_PROFILE_DETAILS_FAILURE: {
      let { error } = action;
      return {
        ...state,
        profileDetailsErr: error,
        isProfileDetailsLoading: false
      }
    }
    case PROFILE.GET_JOB_DETAILS:
    case PROFILE.GET_DEPARTMENT_DETAILS:
    case PROFILE.GET_LANGUAGE_DETAILS:{
      return {
        ...state,
        isLoading: true
      }
    }

    case PROFILE.GET_JOB_DETAILS_SUCCESS:{
      let { response } = action;
      return{
        ...state,
        JobDetails: response,
      }
    }
    case PROFILE.GET_DEPARTMENT_DETAILS_SUCCESS:{
      let { response } = action;
      return{
        ...state,
        departments: response,
      }
    }
    case PROFILE.GET_LANGUAGE_DETAILS_SUCCESS:{
      let { response } = action;
      let formattedLanguage = sortLanguage(response).map((item) => {return{key: item.language, text: item.language}});
      return{
        ...state,
        languages: formattedLanguage ? formattedLanguage : [],
        isLoading: false
      }
    }
    case PROFILE.GET_JOB_DETAILS_FAILURE:
    case PROFILE.GET_DEPARTMENT_DETAILS_FAILURE:
    case PROFILE.GET_LANGUAGE_DETAILS_FAILURE:
    case PROFILE.UPDATE_ERROR:{
      const { errorValue } = action;
      return {
        ...state,
        formError: setFormError(state.formError, errorValue),
        isErrorDisplay: setErrorDisplay(state.formError)
      }
    }

    case PROFILE.UPDATE_PROFILE_DETAILS: {
      let { request } = action;
      return {
        ...state,
        updateRequest: request,
        isLoading: true
      }
    }
    case PROFILE.UPDATE_PROFILE_DETAILS_SUCCESS: {
      let { response } = action;
      return {
        ...state,
        updateDetails: response,
        isLoading: false,
        showToast: true,
        showNativeToast: true,
      }
    }
    case PROFILE.DISPLAY_TOAST: {
      let { val } = action;
      return {
        ...state,
        showToast: val
      }
    }
    case PROFILE.DISPLAY_NATIVE_TOAST: {
      let { val } = action;
      return {
        ...state,
        showNativeToast: val
      }
    }
    case PROFILE.UPDATE_PROFILE_DETAILS_FAILURE: {
      let { error } = action;
      return {
        ...state,
        updateDetailsErr: error,
        isLoading: false
      }
    }
    case PROFILE.UPDATE_FIELD_VALUE: {
      const { fieldValue: newValue } = action;
      return {
        ...state, fieldValue: { ...state.fieldValue, ...newValue }
      }
    }
 
    case PROFILE.RESET_VALUES: {
      return {
        ...state,
        formError: {},
        isErrorDisplay: false
      }
    }
    default:
      return state
  }
}

const setFormError = (formError, errorObj) => {
  for (let i in errorObj) {
    if (errorObj[i] === '') {
      if (formError[i]) delete formError[i];
    } else {
      formError = { ...formError, ...errorObj }
    }
  }
  return formError;
}

const setErrorDisplay = (formError) => {
  let isErrorDisplay = false;
  if (Object.entries(formError).length > 0) {
    isErrorDisplay = true;
  }
  return isErrorDisplay;
}

const sortLanguage = (response) =>{
  response.sort((a, b) => {
    let languageFirst = a.language.toLowerCase(),
    languageSecond = b.language.toLowerCase();

    if (languageFirst < languageSecond) {
        return -1;
    }
    if (languageFirst > languageSecond) {
        return 1;
    }
    return 0;
  });
  return response;
}

export default profileReducer;